// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/chunks/" + (chunkId === 362 ? "1b041c9c" : chunkId) + "." + {"111":"e9faaca524c09195","362":"f99b664f1271d4cb","602":"231a2bfac2020df9"}[chunkId] + ".js";
};